// Map of univId -> tag configuration
// type: 'gtm'  -> Google Tag Manager (GTM-XXXX)
// type: 'gtag' -> Google tag / gtag.js (G-XXXX or AW-XXXX or UA-XXXX)
export const GTM_CONFIG = {
  '99':  { id: 'GTM-WK896C46', type: 'gtm' },   // Sample
  '136': { id: 'GTM-WK896C46', type: 'gtm' },   // JIIT
  '129': [
    { id: 'G-FZ91VE9BVC', type: 'gtag' },
    { id: 'GTM-K2VHM8SG', type: 'gtm' },
  ],  // IIM Bodh Gaya
  '156': [
    { id: 'G-3SDCPR6DW4', type: 'gtag' },
    { id: 'GTM-KZBHJJWC', type: 'gtm' },
  ],  // IIM Mumbai
  '142': [
    { id: 'G-LJLX9BZRK1', type: 'gtag' },
    { id: 'GTM-KHK23WDC', type: 'gtm' },
  ],  // IIM Sambhalpur
  '113': [
    { id: 'G-3E1MVBQKK9', type: 'gtag' },
    { id: 'GTM-PDQ3P7X7', type: 'gtm' },
  ],  // IIM Kashipur
  '93':  [
    { id: 'G-3V21XGMLN1', type: 'gtag' },
    { id: 'GTM-NGZ2CN7Z', type: 'gtm' },
  ],  // IIT Patna
  '105': [
    { id: 'G-TYDN975JW9', type: 'gtag' },
    { id: 'GTM-MT9KQ97P', type: 'gtm' },
  ],  // IIT Jammu
  '130': [
    { id: 'G-7N443NWVG0', type: 'gtag' },
    { id: 'GTM-WS84DXXV', type: 'gtm' },
  ], // IIIT Vadodara
  '112': [
    { id: 'G-TN90YL508H', type: 'gtag' },
    { id: 'GTM-TD3J88NH', type: 'gtm' },
  ],  // IIT Bhilai

  // IIIT Sri City
  '135': [
    { id: 'G-8BVPG63NFL', type: 'gtag' },
    { id: 'GTM-WTPCJRJ6', type: 'gtm' },
  ],

  // IIM Udaipur
  '145': [
    { id: 'G-QN47E3ST87', type: 'gtag' },
    { id: 'GTM-KN4NP3Q9', type: 'gtm' },
  ],

  // ADAMAS University (regular + Hybrid/New Gen Campus)
  // '162': { id: 'G-QE1Y1LW5BF', type: 'gtag' },
  '163': [
    { id: 'G-QE1Y1LW5BF', type: 'gtag' },
    { id: 'GTM-KQSC88HJ', type: 'gtm' },
  ],

  // Aligarh Muslim University (AMU, AMU-O, AMU-MEA)
  // '24': { id: 'G-GZSJZKMSFD', type: 'gtag' },
  '70': [
    { id: 'G-SR2G9XRQ3M', type: 'gtag' },
    { id: 'GTM-WPNNFD9J', type: 'gtm' },
  ],
  // '78': { id: 'G-GZSJZKMSFD', type: 'gtag' },

  // Arka Jain University
  '154': [
    { id: 'G-08ZD14CWYJ', type: 'gtag' },
    { id: 'GTM-P994R3JL', type: 'gtm' },
  ],
  // Chaudhary Charan Singh University (CCSU)
  '150': [
    { id: 'G-GRVJ4ZCDFB', type: 'gtag' },
    { id: 'GTM-M5WVJMFN', type: 'gtm' },
  ],

  // Jain University (JU-CDOE, JU)
  '41': [
    { id: 'G-KPJ80Y7D5E', type: 'gtag' },
    { id: 'GTM-MWDVXTXB', type: 'gtm' },
  ],
  // '84': { id: 'G-VRVEP4X19Z', type: 'gtag' },

  // Andhra University (AU, AU-INT)
  '100': [
    { id: 'G-240RRYG0J8', type: 'gtag' },
    { id: 'GTM-P4PW278D', type: 'gtm' },
  ],
  // '117': { id: 'G-MNLBFKHD1J', type: 'gtag' },

  // SAGE University Bhopal
  '167': [
    { id: 'G-799TPJBZEF', type: 'gtag' },
    { id: 'GTM-WDJRJBJ6', type: 'gtm' },
  ],

  // Swami Rama Himalayan University (SRHU Online)
  '146': [
    { id: 'G-GS0MC0SGE3', type: 'gtag' },
    { id: 'GTM-K2JG6QSR', type: 'gtm' }
  ],

  // Universal Skill Tech University (USTU)
  '172': [
    { id: 'G-5774WPSBXC', type: 'gtag' },
    { id: 'GTM-WP57XHT3', type: 'gtm' }
  ],

  // Jamia Hamdard (JAMIAH, JAMIAH-MEA)
  '72': [
    { id: 'G-EL6CJ5E763', type: 'gtag' },
    { id: 'GTM-NDKMS6LG', type: 'gtm' },
  ],
  // '80': { id: 'G-EL6CJ5E763', type: 'gtag' },

  // Mizoram University Online (MZU-O, MZU-O New)
  '67':  [
    { id: 'G-6C584YRFQE', type: 'gtag' },
    { id: 'GTM-WHRDX56M', type: 'gtm' },
  ],
  // '147': { id: 'G-6C584YRFQE', type: 'gtag' },

  // Sambalpur University
  '75': [
    { id: 'G-28BV8QVK2E', type: 'gtag' },
    { id: 'GTM-NRDMWRCD', type: 'gtm' },
  ],

  // Srinivas University (SUCDOE)
  '155': [
    { id: 'G-RNN21YHJ1B', type: 'gtag' },
    { id: 'GTM-W29VZDKZ', type: 'gtm' },
  ],

  // Guru Nanak Dev University (GNDU, GNDU-INT)
  '161': [
    { id: 'G-0Q8S7EYLRZ', type: 'gtag' },
    { id: 'GTM-T5PRDNT3', type: 'gtm' },
  ],
  // '164': { id: 'G-0Q8S7EYLRZ', type: 'gtag' },

  // Ganpat University Online
  '128': [
    { id: 'G-HBK5Q8X0YK', type: 'gtag' },
    { id: 'GTM-N9QG86T8', type: 'gtm' }
  ],
  // Deen Dayal Upadhyaya Gorakhpur University (DDUGU)
  '134': [
    { id: 'G-JKWTEJMH1R', type: 'gtag' },
    { id: 'GTM-K6KP2SSC', type: 'gtm' }
  ],

  // AMET University
  '107': [
    { id: 'G-35JY8T86E6', type: 'gtag' },
    { id: 'GTM-MQDKMV77', type: 'gtm' }
  ],

  // Chandigarh University (CU Organic - WLP)
  '65': [
    { id: 'G-VFV1P2RED1', type: 'gtag' },
    { id: 'GTM-M9FHR9GS', type: 'gtm' },
  ],

  // Bundelkhand University (BHU)
  '174': [
    { id: 'G-K1Z032TCXK', type: 'gtag' },
    { id: 'GTM-NKF3JXLV', type: 'gtm' },
  ],

  // HBSU
  '143': { id: 'G-QJ16HS8C50', type: 'gtag' },

  //DBRAU CDOE
  '166': [
    { id: 'G-ERRCHXGPTX', type: 'gtag' },
    { id: 'GTM-PSK6MC4Z', type: 'gtm' },
  ],
};

export function getGtmConfig(univId) {
  if (univId === null || univId === undefined) return null;
  return GTM_CONFIG[String(univId)] || null;
}
